import { useDispatch, useSelector } from "react-redux";

import { Form, Formik } from "formik";

import { toast } from "react-toastify";

import SoftBox from "components/SoftBox";

import { initialValues } from "layouts/Flow Designer/components/Titlebar/components/CreateFlowVersionDialog/schemas/initalValues";
import { validations } from "layouts/Flow Designer/components/Titlebar/components/CreateFlowVersionDialog/schemas/validations";
import { flowVersion } from "layouts/Flow Designer/components/Titlebar/components/CreateFlowVersionDialog/schemas/flowVersion";

import FormField from "layouts/Flow Designer/components/FormField";

import { setFlowVersions, setSavedFlow } from "redux/actions/flowDesigner/flowsActionCreator";

import { insertFlowVersion } from "api/FlowVersions";

const CreateFlowVersionForm = ({ formRef, flowVersions, handleCloseDialog, isCreateFlowVersionDialog }) => {
   const { currentSavedFlow } = useSelector((state) => state.designer.flows);
   const dispatch = useDispatch();
   const {
      formId,
      formField: { createNewVersion }
   } = flowVersion;

   const handleFormSubmit = async (values) => {
      //  Call insert new flow version API here with values
      const versionType = values[createNewVersion.name];

      const insertFlowVersionResponse = await insertFlowVersion(currentSavedFlow.tenant_id, currentSavedFlow.id, currentSavedFlow.name, versionType);

      if (insertFlowVersionResponse.isSuccessful === true) {
         toast.success("New flow version created successfully!");

         const now = new Date().toISOString();

         const newFlowVersion = {
            flow_id: currentSavedFlow.id,
            name: currentSavedFlow.name,
            connectors: currentSavedFlow.connectors,
            credentials: currentSavedFlow.credentials,
            steps: currentSavedFlow.steps,
            status: "draft",
            tags: null,
            created_datetime: now,
            updated_datetime: now
         };

         dispatch(setFlowVersions([...flowVersions, Object.assign(newFlowVersion, insertFlowVersionResponse.resultObject)]));
         dispatch(
            setSavedFlow({
               ...currentSavedFlow,
               shared_status: currentSavedFlow.status === "active" ? "active" : "test",
               current_version: insertFlowVersionResponse.resultObject.version,
               steps: currentSavedFlow.steps
            })
         );
      } else {
         toast.error("Failed to create new flow version.");
      }

      handleCloseDialog();
   };

   return (
      <Formik initialValues={initialValues} validationSchema={validations} onSubmit={handleFormSubmit} innerRef={formRef}>
         {() => {
            return (
               <SoftBox className="border-top" sx={{ paddingTop: "20px" }}>
                  <Form id={formId} autoComplete="off">
                     <FormField
                        name={createNewVersion.name}
                        type={createNewVersion.type}
                        label={isCreateFlowVersionDialog ? createNewVersion.label : "Add version"}
                        menuPlacement="bottom"
                        defaultValue={createNewVersion.options.find((o) => o.value === "minor_version")}
                        options={createNewVersion.options}
                        required
                     />
                  </Form>
               </SoftBox>
            );
         }}
      </Formik>
   );
};

export default CreateFlowVersionForm;
